import React, { useState, useEffect } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';

// import ChatWindow from './ChatWindow/ChatWindow';
// import ChatInput from './ChatInput/ChatInput';
import { getCurrentEnvironment } from '../../../constants/api';
import { ShowNotification } from '../../../utils/toast-service';
import { pure } from 'recompose';
import LogoIconNew from '../../../public/img/common/48.png';

import './NotificatioinPannel.less';
import { getNotificationMasterData } from '../../../store/layout/actions';

function AllocationNotification(props) {
  const [connection, setConnection] = useState(null);
  // const [showBell, setShowBell] = useState(true);

  // const [chat, setChat] = useState([]);
  // const [message, setMessage] = useState([]);
  // const latestChat = useRef(null);

  // latestChat.current = chat;
  // let isActiveTab = true;
  // document.addEventListener("visibilitychange", function () {
  //   isActiveTab = document.hidden ? false : true;
  // });

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(getCurrentEnvironment().baseUrl + 'servernotification')
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
  }, []);

  useEffect(() => {
    let groupName = '';
    let userName = '';
    if (props !== undefined && props !== null) {
      if (props.userData !== null && props.userData !== undefined) {
        groupName = props.userData.groups[0]?.configurationName;
        userName = props.userData.email;
      }
    }

    // console.log(groupName);
    if (connection) {
      if (!('Notification' in window)) {
        // console.log('This browser does not support desktop notification');
      } else {
        Notification.requestPermission();
      }
      connection.start()
        .then(result => {
          connection.on('ReceiveMessage', message => {
            // const updatedChat = [...latestChat.current];
            // console.log(message);
            // console.log(groupName);
            // console.log(message.parentRecordId);
            // console.log(message.feature);
            // console.log(message.module);
            // message.recipientGroups.push('');
            // const isGroupPresent = message.Recipient.split('|').includes(groupName);
            // updatedChat.push(message);
            // setChat(updatedChat);
            // setMessage(message);
            // props.userData.userMarket
            // Here we need to check market also : marketId
            const isMarketAssigned = props.userData.userMarket.some(m => m.marketId.toString() === message.marketId);
            // const parentRecordId = message.parentRecordId.indexOf('-') === -1 ? undefined : message.parentRecordId.split('-')[1]
            const showWindowsNotification = false;
            // if (isActiveTab) {

            if ((userName === message.userEmail && userName !== message.createdBy) ||
              (groupName === message.recipient && isMarketAssigned && userName !== message.createdBy)) {
              // ShowNotification(message.notification, 10000, message.notificationMasterId, message.feature, message.module, message.isClickable, message.createdBy, message.createdDate, message.isApprovedNotification);
              ShowNotification(message.notification, 8000, message.parentRecordId, message.feature, message.module, message.isClickable, message.createdBy, message.createdDate, message.isApprovedNotification);
              getNotificationMasterData();
              if (showWindowsNotification) {
                const notificationText = message.notification.indexOf('(Review') !== -1
                  ? message.notification.split('(Review')[0] + '\n' + message.notification.slice(message.notification.indexOf('(Review'))
                  : message.notification;
                const notif = new Notification(message.feature, {
                  icon: window.location.origin + '/' + LogoIconNew,
                  body: notificationText// message.notification,
                });
                // console.log(window.location);
                notif.onclick = function (event) {
                  event.preventDefault();
                  window.open(window.location.origin + '/pendingRequests', '_self');
                  // if (message.isClickable) {
                  //   window.open(window.location.origin + '/pendingRequests?parentRecordId=' + parentRecordId + '&module=' + message.module + '&feature=' + message.feature, '_blank');
                  // }
                  // else if (message.module.includes('Assignments')) {
                  //   window.open(window.location.origin + '/Assignments?parentRecordId=' + parentRecordId + '&module=' + message.module + '&feature=' + message.feature, '_blank');
                  // }
                  // else if (message.module.includes('Allocations')) {
                  //   const type = feature.includes('Market') ? 'Market' : 'Property';
                  //   window.open(window.location.origin + '/allocations?type=' + type + '&id=' + parentRecordId, '_blank');
                  // }
                  // window.focus();
                };
              }
            }
            // }
          });
        })
        .catch(e => console.log('Connection failed: ', e));
    }
  }, [connection]);

  // const sendMessage = async (user, message) => {
  //   const chatMessage = {
  //     user: user,
  //     message: message
  //   };

  //   if (connection.connectionStarted) {
  //     try {
  //       await connection.send('SendMessage', chatMessage);
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   } else {
  //     alert('No connection to server yet.');
  //   }
  // };

  return (
    <div>
      {/* <ChatInput sendMessage={sendMessage} />
            <hr />
            <ChatWindow chat={chat}/> */}
    </div>
  );
}

export default pure(AllocationNotification);
